import { render, staticRenderFns } from "./StateGovernmentMonitoring.vue?vue&type=template&id=f082070a&scoped=true&"
import script from "./StateGovernmentMonitoring.vue?vue&type=script&lang=js&"
export * from "./StateGovernmentMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./StateGovernmentMonitoring.vue?vue&type=style&index=0&id=f082070a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082070a",
  null
  
)

export default component.exports